var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskAnimalObservation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22.818 12S18.363 5 12 5C5.572 5 1.18 12 1.18 12S4.363 19 12 19c7.573 0 10.818-7 10.818-7m-6.364 0A4.426 4.426 0 0 1 12 16.454 4.426 4.426 0 0 1 7.546 12 4.426 4.426 0 0 1 12 7.546 4.426 4.426 0 0 1 16.454 12M12 13.91a1.909 1.909 0 1 1-.001-3.818 1.909 1.909 0 0 1 0 3.817",
  clipRule: "evenodd"
})));
export default SvgTaskAnimalObservation;